import { HEADER_HEIGHT } from '@/components/AppHeader';
import { SIDEBAR_EXPANDED_WIDTH, SIDEBAR_WIDTH } from './constants';

export const classes = {
  sidebar:
    'fixed left-0 bottom-0 z-20 overflow-hidden flex flex-col gap-1 px-5 py-6 bg-sage-10 transition-width duration-[220ms] ease-in-out hover:shadow-sidebar',
  divider: 'border-mint-2/[.16] my-2',
};

export const styles = {
  sidebar: (isExpanded: boolean) => ({
    top: HEADER_HEIGHT,
    width: isExpanded ? SIDEBAR_EXPANDED_WIDTH : SIDEBAR_WIDTH,
  }),
};
